import(/* webpackMode: "eager" */ "/home/runner/work/trusty-frontend/trusty-frontend/app/global-error.tsx");
